// extracted by mini-css-extract-plugin
var _1 = "LoginView-module__emailText--Mgc4_";
export { _1 as "emailText" }
